export default "__VITE_ASSET__dfc0872d__"